import { Box } from "@mui/material";

const CircularProgressBar = ({
  percentage,
  label,
  level,
  size = 240,
  strokeWidth = 10,
}: any) => {
  const radius = size / 2 - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <Box
      sx={{
        cursor: "pointer",
        borderRadius: "120px",
        "&:hover": {
          "& .circular-progress-bar": {
            stroke: "var(--c-second-color)",
          },
          "& .circular-bg": {
            stroke: "var(--c-main-color)",
          },
          "& .progress-text": {
          boxShadow: "-2px -2px 3px 0px rgba(255,255,255,0.1), 5px 5px 5px 0px rgba(0,0,0,0.5), inset -5px -5px 5px -5px rgba(255, 255, 255, 0.30), inset 5px 5px 5px 0px rgba(0, 0, 0, 0.30)",

          },
        },
      }}
      className="progress-container"
    >
      <svg width={size} height={size} className="circular-progress">
        <circle
          className="circular-bg"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          className="circular-progress-bar"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: 1,
          border: "5px solid var(--c-bg-content-color)",
          boxShadow: "var(--c-box-shadow-btn)",
          borderRadius: `${size - strokeWidth * 2}px`,
          width: `${size - strokeWidth * 2}px`,
          height: `${size - strokeWidth * 2}px`,
          zIndex: 99,
        }}
        className="progress-text"
      >
        <Box sx={{ fontSize: 24 }}>{label}</Box>
        <Box sx={{ fontSize: 16 }}>{level}</Box>
      </Box>
    </Box>
  );
};

export default CircularProgressBar;
